<template>
<div>
 <alert-box  @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
 <div v-if="spinner" class="text-center">
  <div class="spinner-grow text-success spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
<confirm-box v-if="cb.show">     
      <template v-slot:header>
        <strong>{{cb.title}}</strong>    
      </template>
      <template v-slot:body1>
        <h4>{{cb.msg1}}</h4>   
      </template>
      <template v-slot:footer>  
        <button @click="cb.show=false" type="button" class="btn btn-secondary">
         
          NO</button>
        <button @click="processModal()" type="button" data-dismiss="modal" class="btn btn-primary">SI</button>
      </template>    
</confirm-box>  

 
<!-- TABLE -->  
<div class="card">
  <h5 class="card-header">LISTA PRODOTTI VENDITA {{item.saleId}} del {{item.create_at}} - {{item.store}}</h5>
  <div class="card-body">
  <div class="productsList" >
  <table class="table mb-0 table-hover pointer ">
    <thead >
      <tr>
      
        <th></th>       
        <th>#</th>       
        <th>BARCODE</th>
        <th>BRAND</th>
        <th>CODICE PRODOTTO</th>
        <th>CATEGORIA</th>
        <th>COLORE</th>
        <th>MISURA</th>
        <th class="text-right">PREZZO</th>
        <th class="text-right">SCONTO</th>
        <th class="text-right">IMPORTO</th>
                
      </tr>
    </thead>
    <tbody>
      <tr
      
      v-for="(item, index) in filteredItems" :key="index">
      
      <td>
        <i @click="deleteProduct(item,index+1)" class="fas fa-trash mr-2"></i>
        
      </td>
      <td>{{index+1}}</td>
      <td>{{item.barcode}}</td>      
      <td>{{item.brand}}</td>      
      <td>{{item.sku}}</td>      
      <td>{{item.category}}</td>      
      <td>{{item.color}}</td>      
      <td>{{item.size}}</td>      
      <td class="text-right">{{fmt(item.price,2)}}</td>   
      <td class="text-right">{{item.discount}}</td>   
      <td class="text-right">{{fmt(item.total,2)}}</td>   
      
        
      </tr> 
    </tbody>

  </table>
  
</div>

     <div class="input-group mb-2 mt-3">
        <div class="input-group-prepend">
          <div class="input-group-text">
              <i  class="fas fa-filter" aria-hidden="true"></i>
          </div>
        </div>

  
    <input class="form-control" type="text" name="query" v-model="filterKey">
     </div>



</div>

    
</div>
       

<div v-if="!editDiscount">
<button  type="button" @click="setEditDiscount()" class="btn btn-primary mt-1 ml-3" > <span v-if="bt_spinner" class="spinner-grow spinner-grow-sm"></span>
       <i class="fas fa-edit mr-2" aria-hidden="true"></i>
       MODIFICA SCONTO</button>      
</div> 

<div v-else >        
  <form v-on:submit.prevent="updateData()">
  <div class="form-row ml-4">  

    <div class="col-4">
         <div class="input-group mt-1 ">
        <div class="input-group-prepend">
          <div class="input-group-text">
              %
          </div>
        </div>


      <input step="0.01" v-focus type="number" class="form-control" placeholder="Sconto" v-model="discount" required>
         </div>
    </div>

    <div class="col">
      <button type="submit"  class="btn btn-primary mt-1">
         <i class="fas fa-edit mr-2" aria-hidden="true"></i>
        AGGIORNA SCONTO</button>  
      <button type="submit" @click="editDiscount=false" class="btn btn-outline-secondary mt-1 ml-3 ">ANNULLA</button>  
    </div>
        
  </div>
  </form>
</div>

  




  
</div>
</template>
<script>
import alertBox           from '@/components/common/AlertBox.vue';
import api                from '@/api'
import { mapGetters }     from 'vuex';

import confirmBox         from '@/components/common/ConfirmBox.vue'

export default {
  props : ['item'],       
  components: {alertBox,confirmBox},
  data() {
    return {
      discount               : 0,
      editDiscount           : false,
      bt_spinner             : false,
      spinner                : false,
      filterKey              : '',
      
     
     
      msg                    : {
        title                : '',
        body                 : '',
        type                 : 0
      }, 
      items                  : [],
      
     
      cb                     : {title : '',msg1 : '',show:false},
     
          
      
    };
  },
  computed :{
   
    ...mapGetters(['storeId','company']) , 
     filteredItems : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     },

     
    total : function() {
   
      let  total = {
        total1 : 0,total2:0,total3:0
      }
      this.items.forEach(item => {
        if(item.rowType==2)
        {
          total.total1 += Number(item.row_total)
          total.total2 += Number(item.totalDiscount)
          total.total3 += Number(item.totalPaid)

        }
      })
      return total
    }


  },
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    }
  },
  mounted: function() {
    
    this.getProdutsData(this.item)
  },
  created: function() {
    console.log(this.item)
  },
  methods: 
  {
    setEditDiscount()
    {
      this.editDiscount = !this.editDiscount
    },
    deleteProduct(item,index)
    {
      this.cb.barcode = item.barcode
      this.cb.Id      = item.id
      this.cb.storeId = item.storeId
      

      this.cb.title = 'ELIMINA RIGA ' 
      this.cb.msg1  = 'SI DESIDERA ELIMINARE LA RIGA  ' + index +  ' ?'
      this.cb.show  = true 
  
    },
    async processModal()
     {
        
        this.cb.show = false
        this.spinner = true
        var data     = {'Id' : this.cb.Id,'storeId':this.cb.storeId,'barcode':this.cb.barcode,'saleId':this.item.saleId}        
        var sp       = {'sp' : 'spDeleteProductFromSale'}
        var json     = Object.assign(data, sp)
        
        await api.post(json).then(res => {
          if(res.status==200)
            {
              this.msg.title = 'ELIMINAZIONE EFFETTUATA.'
              this.msg.body = ''
              this.msg.type = 0
              this.getProdutsData(this.item)
              

            }
            else if(res.status==500)
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data 
              this.msg.type = 1
            } 
            else
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1

            } 
        }).catch(err => 
        {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1

        }).finally(() => {
             this.spinner = false
        });
        
        
        
     
     },

    async updateData()
     {
        
        
        this.spinner = true
        var data     = {'movementId' : this.item.stockMovementId,'discount':this.discount}        
        var sp       = {'sp' : 'spUpdateProductsSaleDiscount'}
        var json     = Object.assign(data, sp)
        
        
       
        await api.post(json).then(res => {
          if(res.status==200)
            {
              //this.msg.title = 'AGGI EFFETTUATA.'
              //this.msg.body = ''
              //this.msg.type = 0
              this.editDiscount = false
              this.getProdutsData(this.item)
              

            }
            else if(res.status==500)
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data 
              this.msg.type = 1
            } 
            else
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1

            } 
        }).catch(err => 
        {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1

        }).finally(() => {
             this.spinner = false
        });
        
        
        
     
     },


     
      

    
      
    fmt(value,fmt)
    { 
      if(!isNaN(value))
      {
      return Number(value).toLocaleString('it-IT',{ style: 'decimal',minimumFractionDigits: fmt ,maximumFractionDigits: fmt});
      }
    },

    async getProdutsData(item) {
      
      this.spinner = true
      this.msg.title = '' 
      this.products = []
      
      
      var sp    = {'sp':'spSaleProducts'}
     
      var data  = {'movementId':item.stockMovementId}
      var json  = Object.assign(data, sp)

      
      await api.post(json).then(res => {
        if(res.status==200)
          {
            this.items    = res.data.recordsets[0]
            

            if(this.items.length ==0 )
            {              
              this.msg.title = "ATTENZIONE "
              this.msg.body = 'DATI INESISTENTI.'
              this.msg.type = 1
     
            }
            
         
          }
          else if(res.status==500)
          {
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res.data
            this.msg.type  = 1

          } 
          else
          {
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1                  
            

          } 
      }).catch(err => 
      {
          
      this.msg.title = 'ATTENZIONE '
      this.msg.body  = err.message
      this.msg.type  = 1  

      }).finally(() => {
        this.spinner = false
      });

    },
    


  }
};
</script>
<style scoped>

.productsList {
    position  : relative;
    height    : 500px;
    overflow  : auto;
}


.fa-print
{
  cursor: pointer
}
.pointer:hover
{
  
  cursor           : pointer;
}


.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : green;
    color        : aliceblue;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }
 .table tfoot  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 24px;
    background   : whitesmoke;
    color        : darkgreen;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 } 

.form-check-label
{
  cursor: pointer;
}
h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
.date_time
{
  font-size: 18px;
}
 .table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}
</style>